export * from './locale.price.format.pipe';
